export default __webpack_public_path__ + "static/media/postCode.9b48350c.svg";